import styles from './UIGameActionButtonTurnToggleCount.module.scss';
import React from 'react';
import IconPlayers from '@static/images/icon_player.svg';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
export const UIGameActionButtonTurnToggleCount = ()=>{
    const currentStateValidator = useCurrentStateValidator();
    const playerStates = useGameStore((state)=>state.gameState.playerStates);
    const numberOfPlayersToggledEndTurn = currentStateValidator.playersToggledEndTurn.length;
    const numberOfPlayers = Object.keys(playerStates).length;
    return /*#__PURE__*/ React.createElement(TurnToggleCount, {
        numberOfPlayersToggledEndTurn: numberOfPlayersToggledEndTurn,
        numberOfPlayers: numberOfPlayers
    });
};
export const TurnToggleCount = ({ numberOfPlayersToggledEndTurn, numberOfPlayers })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("img", {
        src: IconPlayers,
        className: styles.icon
    }), /*#__PURE__*/ React.createElement("span", null, numberOfPlayersToggledEndTurn), /*#__PURE__*/ React.createElement("span", null, "/"), /*#__PURE__*/ React.createElement("span", null, numberOfPlayers));
